import ReactGA from "react-ga";

import getVar from "constants/.";
import history from "../history";

const initializeAnalytics = () => {
  const trackingId = getVar("GA_TRACKING_ID");

  if (trackingId) {
    ReactGA.initialize(trackingId);
    history.listen(({ location }) =>
      ReactGA.pageview(location.pathname + location.search)
    );
  }
};

export default { initializeAnalytics };
